export default function Badge({ children, theme = 'default' }) {
  const themes = {
    default: 'bg-gradient-to-r from-purple-700 via-red-600 to-amber-500 text-white animate-gradient',
    outline: 'bg-gray-50 ring-1 ring-inset ring-gray-400 text-gray-600',
    simple: 'bg-red-500/10 text-red-400 ring-1 ring-inset ring-red-500/20',
  };
  return <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium shadow-sm ${themes[theme]}`}>{children}</span>;
}
